/* eslint-disable no-console */
import { Form, Input, Typography } from 'antd';
import { AiOutlineLock, AiOutlineUser } from 'react-icons/ai';
import { useHistory, useParams } from 'react-router-dom';

import { AuthLayout } from '../../../components/AuthLayout';
import { Button } from '../../../components/Common/Button';
import { Logo } from '../../../components/Common/Logo';
import { useMobileVersion } from '../../../hooks/useMobileVersion';
import { registerInvited } from '../../../operations/users';
import * as registerInvitedRules from '../../../rules/register-invited';
import { ContainerAuth, FormAuth, LinkAuth } from '../../../styles/common/auth';
import { ContentStyled, TitleStyled } from '../Register/styles';

type Params = {
  apiToken: string;
};

const { Title, Paragraph } = Typography;

export const RegisterInvited = () => {
  const history = useHistory();
  const { apiToken } = useParams<Params>();
  const isMobileVersion = useMobileVersion();

  const handleSubmit = async (values: any) => {
    try {
      await registerInvited({
        token: apiToken,
        name: values.name,
        password: values.password,
        password_confirmation: values.passwordConfirm,
      });
      history.push('/login');
    } catch (error) {
      console.log(error);
    }
  };

  const RegisterPasswordForm = () => (
    <FormAuth
      id="registerInvitedForm"
      onFinish={handleSubmit}
      style={{ minWidth: 330 }}
    >
      <Form.Item name="name" rules={registerInvitedRules.name}>
        <Input prefix={<AiOutlineUser />} placeholder="Nome" size="large" />
      </Form.Item>
      <Form.Item
        name="password"
        hasFeedback
        rules={registerInvitedRules.password}
      >
        <Input.Password
          prefix={<AiOutlineLock />}
          placeholder="Senha"
          size="large"
        />
      </Form.Item>

      <Form.Item
        name="passwordConfirm"
        dependencies={['password']}
        hasFeedback
        rules={registerInvitedRules.passwordConfirm}
      >
        <Input.Password
          prefix={<AiOutlineLock />}
          placeholder="Repetir senha"
          size="large"
        />
      </Form.Item>
    </FormAuth>
  );

  if (isMobileVersion) {
    return (
      <ContainerAuth>
        <Logo height={35} />
        <TitleStyled>Bem-vindo ao painel contábil</TitleStyled>
        <ContentStyled>
          <h2>Criar conta</h2>
          <p>Cadastre seu nome e senha para acessar</p>
          <RegisterPasswordForm />
          <LinkAuth to="/login">Já possuo login</LinkAuth>
          <Button form="registerInvitedForm" block htmlType="submit">
            Criar conta
          </Button>
        </ContentStyled>
      </ContainerAuth>
    );
  }

  return (
    <AuthLayout>
      <div style={{ maxWidth: 330, textAlign: 'center' }}>
        <Title level={4} style={{ textAlign: 'center' }}>
          Bem-vindo ao painel contábil
        </Title>
        <Paragraph style={{ fontSize: '20px', textAlign: 'center' }}>
          Cadastre seu nome e senha para acessar
        </Paragraph>
        <RegisterPasswordForm />
        <Button form="registerInvitedForm" block htmlType="submit">
          Criar conta
        </Button>
        <LinkAuth style={{ marginTop: '10px' }} to="/login">
          Já possuo login
        </LinkAuth>
      </div>
    </AuthLayout>
  );
};
